import type { OgeTopicPick } from "@edu/shared";
import {
  subjectOfSource,
  subjectOfTopicSource,
  type SourceKind,
  type TopicSource,
  type TopicSubject,
} from "./subjects.ts";
import { useTopicPicks, type TopicPicks } from "../../exercises/topics/use-topic-picks.ts";

/**
 * Справочники тем ОБОИХ предметов и тот из них, что сейчас открыт (раздел 7,
 * пункт 15 `docs/english-generators-design.md`).
 *
 * Отдельным хуком от формы затем, чтобы выбор предмета делался в одном месте.
 * Мест этих иначе три (какая ветка рисуется, из какой собирается заказ, в какую
 * ложатся строки восстановленной раздачи), и разъехавшись, они дали бы самое
 * тихое из возможных расхождений: английские слаги, уехавшие в математический
 * реестр. Отказ у такого заказа приезжает не преподавателю в форму, а ученику в
 * работу.
 *
 * ⚠️ Состояний ДВА, и оба живут всё время, пока открыта форма. Один хук с
 * переключаемым предметом стоил бы набранных строк при каждом нажатии на
 * радиокнопку: строки хранят слаги, а слаги у предметов разные. Переключатель
 * источника обязан быть обратимым, иначе заглянуть в соседний предмет означает
 * потерять набранное.
 */

export interface TopicSources {
  /** По состоянию на предмет. Строки-пики у каждого свои. */
  readonly bySubject: Readonly<Record<TopicSubject, TopicPicks>>;
  /** Справочник открытой ветки. У заготовки предмета нет, отдаётся математика. */
  readonly active: TopicPicks;
  /** Строки восстановленной раздачи ложатся в справочник СВОЕГО предмета. */
  readonly restore: (kind: TopicSource, picks: readonly OgeTopicPick[]) => void;
}

export function useTopicSources(kind: SourceKind): TopicSources {
  const bySubject: Record<TopicSubject, TopicPicks> = {
    math: useTopicPicks("math", "homework"),
    english: useTopicPicks("english", "homework"),
  };

  return {
    bySubject,
    active: bySubject[subjectOfSource(kind) ?? "math"],
    restore: (source, picks) => bySubject[subjectOfTopicSource(source)].restore(picks),
  };
}
